
























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { supportedLocales } from '@/internationalization';
import GlobalProgressBar from '@/Shared/GlobalProgressBar.vue';
import { SetLastMovement, CountDown } from '@/Shared/Inactivity';

const listOfEvents = [
    'click',
    'change',
    'dblclick',
    'mousedown',
    'mouseleave',
    'mouseenter',
    'mousemove',
    'mouseout',
    'mouseover',
    'mouseup',
    'mousewheel',
    'whell',
    'keydown',
    'keypress',
    'keyup',
    ];
export default Vue.extend({
    components: {
        GlobalProgressBar
    },
    created() {
        for (const ev of listOfEvents) {
            document.addEventListener(ev,
            async () => {
                if (!this.inactiveUser) {
                    SetLastMovement(new Date());
                }
            });
        }
    },
    computed: {
        ...mapGetters('userModule', [
            'userName',
            'inactive'
        ]),
        inactiveUser: {
            get() {
                return this.inactive;
            },
            set(val: boolean) {
                this.$typedStore.modules.userModule.mutations.inactiveUser(false);
                SetLastMovement(new Date());
                if (val) {
                    // log out and return to login page
                    clearInterval(this.countDownTimer);
                    this.$typedStore.modules.userModule.actions.logout();
                    this.$router.push({
                        name: 'vatsLogin'
                    });
                } else {
                    this.countDownText = '';
                    this.$typedStore.modules.userModule.actions.refreshSession();
                }
            }
        },
        countDown() {
            return this.countDownText;
        }
    },
    data: () => ({
            supportedLocales,
            countDownTimer: 0 as number | undefined,
            countDownText: '' as string
    }),
    methods: {
        selectLocale(locale: string) {
            this.$store.commit('setCurrentLocale', locale);
        }
    },
    watch: {
        countDownText: {
            handler(val) {
                if (val === '00:00') {
                    this.inactiveUser = true;
                }
            }
        },
        inactiveUser: {
            handler(val) {
                if (val) {
                    this.countDownTimer = setInterval(() => { this.countDownText = CountDown(new Date()); }, 500);
                } else {
                    if (this.countDownTimer !== undefined) {
                        clearInterval(this.countDownTimer);
                    }
                }
            }
        }
    }
});
